import { ACHIEVEMENT_META } from "@/lib/achievements";

/**
 * AchievementBadge - a single collectible badge.
 * Props: id, name, icon, description, unlockedAt, size ('sm'|'md'|'lg'), showName
 */
export default function AchievementBadge({ id, name, icon, description, unlockedAt, size = "md", showName = false, testId }) {
  const meta = ACHIEVEMENT_META[id] || {};
  const displayIcon = icon || meta.icon || "🎖";
  const displayName = name || meta.name || id;
  const color = meta.color || "#A1A1AA";
  const sizes = {
    sm: { wrap: "w-8 h-8", text: "text-lg" },
    md: { wrap: "w-12 h-12", text: "text-2xl" },
    lg: { wrap: "w-16 h-16", text: "text-3xl" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className="inline-flex items-center gap-3" title={description || displayName} data-testid={testId}>
      <div
        className={`${s.wrap} rounded-xl flex items-center justify-center flex-shrink-0 relative`}
        style={{
          background: `linear-gradient(135deg, ${color}30, ${color}10)`,
          border: `1px solid ${color}50`,
          boxShadow: `0 0 20px -8px ${color}60`,
        }}
      >
        <span className={s.text} style={{ filter: "grayscale(0)" }}>{displayIcon}</span>
      </div>
      {showName && (
        <div className="min-w-0">
          <div className="font-medium truncate">{displayName}</div>
          {description && <div className="text-xs text-zinc-500 truncate">{description}</div>}
          {unlockedAt && <div className="text-xs text-zinc-600 mt-0.5">Låst op {new Date(unlockedAt).toLocaleDateString("da-DK")}</div>}
        </div>
      )}
    </div>
  );
}
